// PROTOTYPE
// This Component is highly subject to change
// This button is specifically designed for root Settings navigation

import React, { useContext } from 'react'
import { css } from 'emotion'
import { Text, View } from 'oio-react'
import PropTypes from 'prop-types'
import { NavLink } from 'react-router-dom'
import ThemeContext from 'src/libraries/contexts/Theme'

const ProtoNavButton = ({
   color,
   icon,
   linkExact,
   linkName,
   linkTo
}) => {
   const theme = useContext(ThemeContext)

   return (
      <NavLink
         exact={linkExact}
         to={linkTo}
         className={css`
            color: #888;
            display: block;
            width: 100%;

            &:hover {
               background-color: rgba(255,255,255,0.025);
            }

            .icon {
               fill: #666;
            }
         `}
         activeClassName={css`
            background-color: rgba(255,255,255,0.05);
            color: #fff !important;

            &:hover {
               background-color: rgba(255,255,255,0.05);
            }

            .dot {
               background-color: ${theme.protoSettingsHighlightBackgroundColor};
            }

            .icon {
               fill: ${theme.protoSettingsHighlightForegroundColor} !important;
            }
         `}>
         <View
            display="flex"
            alignItems="center"
            padding="10px 20px">
            <View
               display="flex"
               justifyContent="center"
               alignItems="center"
               className="dot"
               width="28px"
               height="28px"
               borderRadius="50%"
               marginRight="15px"
               textAlign="center">
               {icon}
            </View>
            <Text size="1.5" weight="medium" color="inherit">
               {linkName}
            </Text>
         </View>
      </NavLink>
   )
}

ProtoNavButton.propTypes = {
   color: PropTypes.string,
   icon: PropTypes.node,
   linkExact: PropTypes.bool,
   linkName: PropTypes.string.isRequired,
   linkTo: PropTypes.string.isRequired
}

ProtoNavButton.defaultProps = {
   color: '#f7b77c',
   icon: undefined,
   linkExact: false
}

export default ProtoNavButton
